import { render, staticRenderFns } from "./PayrollDetail.vue?vue&type=template&id=4a894fe7&scoped=true&"
import script from "./PayrollDetail.vue?vue&type=script&lang=js&"
export * from "./PayrollDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDetail.vue?vue&type=style&index=0&id=4a894fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a894fe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a894fe7')) {
      api.createRecord('4a894fe7', component.options)
    } else {
      api.reload('4a894fe7', component.options)
    }
    module.hot.accept("./PayrollDetail.vue?vue&type=template&id=4a894fe7&scoped=true&", function () {
      api.rerender('4a894fe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/PayrollDetail.vue"
export default component.exports